import colors from '../config/theme/colors'

export default function useListColors() {
    const listColors: string[] = [
        colors.accent,
        colors.orange[400],
        colors.red[700],
        colors.red[600],
        colors['alo-gray'],
        colors.dark
    ]

    function get(index: number) {
        const i = index % 6
        return listColors[i]
    }

    return {
        colors: listColors,
        get
    }
}
